module.exports = __webpack_public_path__ + "img/9.4f95a180.png";